import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormInputTextComponent } from './form-input-text.component';
import { InputTextModule } from 'primeng/inputtext';
import { KeyFilterModule } from 'primeng/keyfilter';
import { FormInputErrorModule } from '../form-input-error/form-input-error.module';
import { SharedModule } from '../../../modules/shared/shared.module';

@NgModule({
  declarations: [
    FormInputTextComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    InputTextModule,
    KeyFilterModule,
    FormInputErrorModule,
  ],
  exports: [
    FormInputTextComponent
  ]
})
export class FormInputTextModule { }
